import React from "react";

const Watermark = () => {
  const env = process.env.REACT_APP_MODE || "development";
  if (env === "production") return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 50,
        right: 50,
        zIndex: 9999,
        opacity: 0.5,
        fontSize: "3rem",
        pointerEvents: "none",
        color: "#808080",
      }}
    >
      {env.toUpperCase()} BUILD
    </div>
  );
};

export default Watermark;
